import { ComponentType, FC, PropsWithChildren } from 'react';

import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';

import { ResumeAuditStatus } from 'src/types/applicantServices';

import RecommendationReady from 'src/pages/ApplicantServicesOrder/components/ResumeAudit/RecommendationReady';
import WaitingRecommendation from 'src/pages/ApplicantServicesOrder/components/ResumeAudit/WaitingRecommendation';

const STATUS_COMPONENT_MAP: Record<ResumeAuditStatus, ComponentType> = {
    [ResumeAuditStatus.Waiting]: WaitingRecommendation,
    [ResumeAuditStatus.Finished]: RecommendationReady,
    [ResumeAuditStatus.Archived]: RecommendationReady,
};

const ResumeAuditOrder: FC<PropsWithChildren> = () => {
    const orderStatus = useSelectorNonNullable(({ resumeAuditOrder }) => resumeAuditOrder.status);

    const Component = STATUS_COMPONENT_MAP[orderStatus];
    return <Component />;
};

export default ResumeAuditOrder;
